import { Dropdown, DropdownChangeParams } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { RepeatInterval } from "./useRecurringTargetDates";
import { BulkWorkorderContext } from "./BulkWorkorderContext";
import { useContext } from "react";

interface RepeatIntervalDropdownProps {
  onDropdownChange: (e: DropdownChangeParams) => void;
}

export function RepeatIntervalDropdown(props: RepeatIntervalDropdownProps) {
  const { recurrenceSettings } = useContext(BulkWorkorderContext);
  const { t } = useTranslation();

  const repeatIntervalOptions = [
    {
      name: t("workorders.repeatIntervals.month"),
      code: RepeatInterval.Monthly,
    },
    {
      name: t("workorders.repeatIntervals.threeMonths"),
      code: RepeatInterval.ThreeMonthly,
    },
    {
      name: t("workorders.repeatIntervals.sixMonths"),
      code: RepeatInterval.SixMonthly,
    },
    { name: t("workorders.repeatIntervals.year"), code: RepeatInterval.Yearly },
    {
      name: t("workorders.repeatIntervals.twoYears"),
      code: RepeatInterval.TwoYearly,
    },
  ];

  return (
    <Dropdown
      options={repeatIntervalOptions}
      optionLabel="name"
      optionValue="code"
      value={recurrenceSettings?.repeatInterval}
      onChange={(e) => props.onDropdownChange(e)}
    />
  );
}
